const subMenu = [
    {
        id: 0,
        title1: '사업소개',
        title2: '이용안내',
        title3: '주차정보',
        title4: '고객지원',
        title5: '마이페이지',
        title6: '사이트맵'
    },
    {
        id: 1,
        menu1: '주차장 소개',
        menu2: '담당부서 안내'
    },
    {
        id: 2,
        menu1: '주차요금 안내',
        menu2: '시설 현황',
        menu3: '정기권 신청',
        menu4: '시간권 구매',
        menu5: '주차장 안내'
    },
    {
        id: 2-1,
        subMenu1: '요금안내',
        subMenu2: '미납주차 요금안내',
        subMenu3: '할인안내'
    },
    {
        id: 2-2,
        subMenu1: '노상주차장 현황',
        subMenu2: '노외주차장 현황',
        subMenu3: '학교주차장 현황'
    },
    {
        id: 3,
        menu1: '실시간 주차정보',
        menu2: '미납정보 조회'
    },
    {
        id: 4,
        menu1: '공지사항',
        menu2: '자주하는 질문',
        menu3: '차량변경/환불요청'
    },
    {
        id: 5,
        menu1: '차량 등록 현황',
        menu2: '정기권 등록 현황',
        menu3: '시간권 구매 현황',
        menu4: '회원정보 수정',
        menu5: '회원 탈퇴',
    },
    {
        id: 5-2,
        subMenu1: '정기권 사용 내역',
        subMenu2: '정기권 신청 내역',
        subMenu3: '정기권 구매 내역',
    },
    {
        id: 5-3,
        subMenu1: '시간권 사용 내역',
        subMenu2: '시간권 구매 내역'
    },
    {
      id: 5-1,
      subMenu1: '차량 등록 관리',
      subMenu2: '차량 할인 관리'   
    },
    {
        id: 6-1,
        subMenu1: '사이트맵'
    }
]

export default subMenu